import { formatNumber } from '@angular/common';
import {
  getEmptyContent,
  isDisplay,
  isValidData,
  Summary
} from '@com-delta-idp/mnx-skymiles-shared';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { logError } from '@com-delta-idp/mnx-utils';
import { Summary as SummaryContent } from '../models/aem/overview.interface';
import { TYPE } from '../models/overview.constants';
import { getTitle } from '../utils/tracker/summary.utils';

export const getSummary = (
  aem: SummaryContent | undefined,
  featureFlag: boolean | undefined,
  availableMiles: string | undefined
): Summary => {
  try {
    return isValidData<
      string,
      [SummaryContent | undefined, string | undefined, boolean | undefined]
    >('summaryTitle', aem, availableMiles, featureFlag)
      ? adaptSummaryObject(
          aem as SummaryContent,
          featureFlag as boolean,
          availableMiles as string
        )
      : isDisplay<Summary>(featureFlag);
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'OVERVIEW', 'SUMMARY');
    return getEmptyContent<Summary>('', [], true, true);
  }
};

const adaptSummaryObject = (
  aem: SummaryContent,
  featureFlag: boolean,
  availableMiles: string
): Summary => {
  if (featureFlag) {
    const miles = formatNumber(
      Number(availableMiles),
      TYPE.LOCALE,
      TYPE.DIGITS_INFO
    ).toString();
    return {
      title: aem.summaryTitle,
      description: aem.description,
      value: miles,
      action: getSummaryButtonLabel(aem, availableMiles),
      ariaLabels: {
        title: getTitle(miles, aem.summaryTitle)
      },
      disabled: !featureFlag,
      loaded: true
    };
  } else {
    return getEmptyContent<Summary>('', [], true, true);
  }
};

const getSummaryButtonLabel = (aem: SummaryContent, miles: string): Link => {
  return {
    label:
      miles === '0'
        ? aem.noMilesLabel.milesLabel
        : aem.withMilesLabel.milesLabel,
    url:
      miles === '0' ? aem.noMilesLabel.milesLink : aem.withMilesLabel.milesLink,
    id: miles === '0' ? aem.noMilesLabel.milesId : aem.withMilesLabel.milesId
  };
};
